import React from 'react';
import { Eye, MousePointerClick, TrendingUp } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
const chartData = [{
  name: 'Mon',
  views: 24,
  clicks: 8
}, {
  name: 'Tue',
  views: 35,
  clicks: 12
}, {
  name: 'Wed',
  views: 42,
  clicks: 15
}, {
  name: 'Thu',
  views: 28,
  clicks: 9
}, {
  name: 'Fri',
  views: 50,
  clicks: 18
}, {
  name: 'Sat',
  views: 45,
  clicks: 14
}, {
  name: 'Sun',
  views: 23,
  clicks: 7
}];
const linkPerformance = [{
  id: 1,
  title: 'Compass',
  url: 'compass.com/agents/marcus-chen',
  clicks: 142,
  percentage: 45
}, {
  id: 2,
  title: 'Website',
  url: 'marcuschen.com',
  clicks: 89,
  percentage: 28
}, {
  id: 3,
  title: 'Realtor.com',
  url: 'realtor.com/realestateagents/marcus-chen',
  clicks: 56,
  percentage: 18
}, {
  id: 4,
  title: 'Selling a home',
  url: 'eaves.pro/marcuschen/selling',
  clicks: 18,
  percentage: 6
}, {
  id: 5,
  title: 'Buying a home',
  url: 'eaves.pro/marcuschen/buying',
  clicks: 10,
  percentage: 3
}];
export function DashboardInsights() {
  return <div className="p-8 max-w-5xl mx-auto" data-id="element-728">
      <div className="flex items-center justify-between mb-8" data-id="element-729">
        <h1 className="text-3xl font-serif font-semibold text-brand-dark" data-id="element-730">
          Insights
        </h1>

        {/* Date Range Selector */}
        <div className="flex items-center bg-white border border-brand-light rounded-full p-1 shadow-sm" data-id="element-731">
          <button className="px-4 py-1.5 bg-brand-offwhite text-brand-dark text-sm font-medium rounded-full" data-id="element-732">
            Last 7 days
          </button>
          <button className="px-4 py-1.5 text-brand-muted hover:text-brand-dark text-sm font-medium rounded-full transition-colors" data-id="element-733">
            Last 28 days
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-734">
        <div className="bg-white p-6 rounded-2xl border border-brand-light shadow-sm" data-id="element-735">
          <div className="flex items-center gap-3 mb-4" data-id="element-736">
            <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center" data-id="element-737">
              <Eye size={20} className="text-brand-forest" data-id="element-738" />
            </div>
            <p className="text-sm font-medium text-brand-muted" data-id="element-739">
              Profile views
            </p>
          </div>
          <div className="flex items-end gap-3" data-id="element-740">
            <h2 className="text-4xl font-mono font-semibold text-brand-dark" data-id="element-741">
              247
            </h2>
            <div className="flex items-center gap-1 text-sm font-medium text-emerald-600 mb-1" data-id="element-742">
              <TrendingUp size={16} data-id="element-743" />
              12%
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-2xl border border-brand-light shadow-sm" data-id="element-744">
          <div className="flex items-center gap-3 mb-4" data-id="element-745">
            <div className="w-10 h-10 rounded-full bg-brand-sage flex items-center justify-center" data-id="element-746">
              <MousePointerClick size={20} className="text-brand-forest" data-id="element-747" />
            </div>
            <p className="text-sm font-medium text-brand-muted" data-id="element-748">Link clicks</p>
          </div>
          <div className="flex items-end gap-3" data-id="element-749">
            <h2 className="text-4xl font-mono font-semibold text-brand-dark" data-id="element-750">
              83
            </h2>
            <div className="flex items-center gap-1 text-sm font-medium text-emerald-600 mb-1" data-id="element-751">
              <TrendingUp size={16} data-id="element-752" />
              8%
            </div>
          </div>
        </div>
      </div>

      {/* Activity Chart */}
      <div className="bg-white p-6 rounded-2xl border border-brand-light shadow-sm mb-8" data-id="element-753">
        <h2 className="text-lg font-medium text-brand-dark mb-6" data-id="element-754">
          Profile activity
        </h2>
        <div className="h-[300px] w-full" data-id="element-755">
          <ResponsiveContainer width="100%" height="100%" data-id="element-756">
            <BarChart data={chartData} margin={{
            top: 10,
            right: 10,
            left: -20,
            bottom: 0
          }} data-id="element-757">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f2ef" data-id="element-758" />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
              fill: '#6b7264',
              fontSize: 12
            }} dy={10} data-id="element-759" />
              <YAxis axisLine={false} tickLine={false} tick={{
              fill: '#6b7264',
              fontSize: 12
            }} data-id="element-760" />
              <Tooltip cursor={{
              fill: '#f7f3ee'
            }} contentStyle={{
              borderRadius: '12px',
              border: '1px solid #f0f2ef',
              boxShadow: '0 4px 20px -2px rgba(45, 106, 79, 0.08)'
            }} data-id="element-761" />
              <Legend iconType="circle" wrapperStyle={{
              paddingTop: '20px'
            }} data-id="element-762" />
              <Bar dataKey="views" name="Views" fill="#2d6a4f" radius={[4, 4, 0, 0]} barSize={24} data-id="element-763" />
              <Bar dataKey="clicks" name="Clicks" fill="#e8f0e4" radius={[4, 4, 0, 0]} barSize={24} data-id="element-764" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Link Performance Table */}
      <div className="bg-white rounded-2xl border border-brand-light shadow-sm overflow-hidden" data-id="element-765">
        <div className="p-6 border-b border-brand-light" data-id="element-766">
          <h2 className="text-lg font-medium text-brand-dark" data-id="element-767">
            Link performance
          </h2>
        </div>

        <div className="divide-y divide-brand-light" data-id="element-768">
          {linkPerformance.map(link => <div key={link.id} className="p-6 flex items-center gap-6 hover:bg-brand-offwhite/50 transition-colors" data-id="element-769">
              <div className="flex-1 min-w-0" data-id="element-770">
                <p className="font-medium text-brand-dark truncate mb-1" data-id="element-771">
                  {link.title}
                </p>
                <p className="text-xs text-brand-muted truncate" data-id="element-772">{link.url}</p>
              </div>

              <div className="w-32 hidden sm:block" data-id="element-773">
                <div className="h-2 w-full bg-brand-offwhite rounded-full overflow-hidden" data-id="element-774">
                  <div className="h-full bg-brand-forest rounded-full" style={{
                width: `${link.percentage}%`
              }} data-id="element-775"></div>
                </div>
              </div>

              <div className="text-right min-w-[80px]" data-id="element-776">
                <p className="font-mono font-medium text-brand-dark" data-id="element-777">
                  {link.clicks}
                </p>
                <p className="text-xs text-brand-muted" data-id="element-778">{link.percentage}%</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}